import React from 'react';
import { ChipTypeMap, Chip as MUIChip, ChipProps as MUIChipProps } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


export type ChipProps<
  D extends React.ElementType = ChipTypeMap['defaultComponent'],
  P = {}
> = MUIChipProps<D, P> & {
  square?: boolean;
};


const useStyles = makeStyles<ChipProps>()({
  root: {},
  square: {
    borderRadius: 'unset',
  },
  deleteIcon: {},
});


export const Chip: React.FC<ChipProps> = React.forwardRef(({ square, ...props }, ref) => {
  const { classes, cx } = useStyles(props, { props });

  return (
    <MUIChip
      {...props}
      ref={ref}
      className={cx(props.className, {
        [classes.square]: square,
      })}
    />
  );
});
